import React from "react";
import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";

const TextFieldDollars = React.forwardRef((props, ref) => {
  const { ...other } = props;
  return (
    <NumericFormat
      {...other}
      decimalScale={2}
      customInput={TextField}
      type="number"
    />
  );
});
export default TextFieldDollars;